module.exports = __webpack_public_path__ + "img/whatsapp-x1.90324371.svg";